import { required, numeric, integer, minValue, maxValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    allocation: {
      inventory_production_batch_input_id: {
        required: helpers.withMessage(i18n.global.t('Please select an input item.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      inventory_lot_id: {
        required: helpers.withMessage(i18n.global.t('Please select a lot.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      actual_quantity: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric),
        maxValue: helpers.withMessage(i18n.global.t('Actual quantity must not exceed the remaining quantity.'), maxValue(formState.remaining_quantity)),
        minValue: helpers.withMessage(i18n.global.t('Quantity must be greater than 0.'), minValue(0.0001))
      },
      actual_cost_per_unit: {
        required: helpers.withMessage(i18n.global.t('Please enter a cost.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cost.'), numeric)
      },
      actual_total_cost: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      unit_id: {
        required: helpers.withMessage(i18n.global.t('Please select a unit.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      }
    }
  }
};
